import BaseModel from './BaseModel';
import { prepareWindowForApi } from '../utils/prepareWindowForApi';

/** Class representing a ticket window. */
class Window extends BaseModel {
    /**
     * Prepare this object for update.
     * This is used to "normalize", if needed, some properties
     * before to send them.
     *
     * return{BaseModel}
     */
    prepareForUpdate() {
        return prepareWindowForApi(this);
    }
}

export default Window;
